import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useLocation } from "react-router-dom"
import { useRef, useState, useEffect } from "react"

import login from '../img/login-bg.png'
import useAuth from "../hooks/useAuth"
import axios from "../api/axios"

const TwoFa = () => {
  const { setAuth } = useAuth()

  const navigate = useNavigate()
  const location = useLocation()

  const [loginAttempts, setLoginAttempts] = useState(1)
  const [maxAttempts] = useState(5)
  
  const [code, setCode] = useState("")

  const [errMsg, setErrMsg] = useState("")

  const [loading, setLoading] = useState(false)

  const codeRef = useRef()
  const errRef = useRef()

  useEffect(() => {
    codeRef.current.focus()
    if (!localStorage.getItem("login")) {
      navigate("/login")
    }
  }, [])

  useEffect(() => {
    setErrMsg("")
  }, [code])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    let data = {
      pin: code,
      id: location.state,
      attempts: loginAttempts,
      origin: 'patient-portal'
    }
    try {
      const response = await axios.post("/2fa/confirm", data)
      if (response.data.error === false) {
        const token = response.data.result.token
        const user = response.data.result.user
        const policyStaff = response.data.result.policyStaff
        setAuth({ user, policyStaff, token })
        localStorage.setItem("token", token)
        setCode("")
        navigate("/", { replace: true })
      }

      if (response.data.error === true) {
        setLoginAttempts(loginAttempts + 1)
        if (loginAttempts < 5 && loginAttempts > 1) {
          setErrMsg("Failed attempt " + loginAttempts + " of " + maxAttempts)
        } else {
          setErrMsg(response.data.message)
          localStorage.removeItem("login")
        }
      }
    } catch (error) {
      if (!error?.response) {
        setErrMsg("No Server Response")
      } else if (error.response?.status === 400) {
        setErrMsg("Email or Password Missing.")
      } else if (error.response?.status === 401) {
        setErrMsg("Incorrect Email or Password entered.")
      } else {
        setErrMsg("Error Occured. Could not log you in.")
      }
      errRef.current.focus()
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div
        className="min-h-screen bg-cover bg-center px-8 relative"
        style={{ backgroundImage: `url(${login})` }}
      >
        <div className="max-w-lg mx-auto w-full space-y-4 md:space-y-6 sm:p-8 md:absolute md:top-[18%] md:right-[20%]">
          <div>
            <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
              <div>
                <h1 className="text-2xl md:text-3xl font-bold">
                  Enter your 2FA code  
                </h1>
              </div>
            </div>
            <h2 className="text-sm md:text-base font-medium">
              We have sent you an email with your 2FA code. Please enter it below to continue.
            </h2>
          </div>

          <p
            ref={errRef}
            className={errMsg ? 'errmsg text-red-600 text-sm' : 'offscreen'}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <form onSubmit={handleSubmit} className="space-y-4 md:space-y-4 max-w-md mx-auto" >
            <div className="w-full">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-700 dark:text-white"
              >
                Code
              </label>
              <input
                type="text"
                ref={codeRef}
                id="code"
                onChange={(e) => {
                  setCode(e.target.value)
                }}
                required
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none focus:border-violet-300 focus:ring-1 focus:ring-violet-300 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              />
            </div>

            <div>
              {loading ? (
                <div className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition text-center mt-2">
                  Loading... <FontAwesomeIcon icon={faSpinner} spin className="ml-2" />
                </div>
              ) : (
                <button className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition text-center mt-2">
                  Confirm
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default TwoFa
